import { render, staticRenderFns } from "./PublicProjectModelDetails.vue?vue&type=template&id=6116356d&scoped=true&"
import script from "./PublicProjectModelDetails.vue?vue&type=script&lang=js&"
export * from "./PublicProjectModelDetails.vue?vue&type=script&lang=js&"
import style0 from "./PublicProjectModelDetails.vue?vue&type=style&index=0&id=6116356d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6116356d",
  null
  
)

export default component.exports